const getConfig = () => {
    return process.env;
};

export const env = getConfig();
